import React from "react";

function Loading() {
  return (
    <div className="loading">
      <div className="loader-wrapper">
        <div className="loader">
          <div className="loader loader-inner "></div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
